export default __webpack_public_path__ + "static/media/es.8b1556d4.svg";